module.exports = {"320684106":"常乐镇","320684108":"悦来镇","320684111":"四甲镇","320684113":"余东镇","320684114":"正余镇","320684117":"海永镇","320684400":"海门市经济技术开发区","320684401":"海门市永隆沙农场","320684403":"海门市大东农场","320684404":"海门市畜禽良种场","320684405":"海门市种羊场","320684406":"海门市包场渔场","320684407":"海门市长江芦荡养殖场","320684408":"海门市沿江渔场","320684409":"海门市三厂苗圃","320684410":"海门市农科所","320684412":"海门市财政局芦荡管理所","320684413":"江苏省国营江心沙农场","320684414":"海门市临江新区管理委员会","320684415":"海门港新区","320684416":"海门工业园区管理委员会","320684417":"海门高新区","320684418":"三厂工业园区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/320684.json
// module id = 983
// module chunks = 0